import { useTranslation } from 'next-i18next'

import DrillTopicElementsList from '~/components/Drill/DrillTopic/components/DrillTopicElemetsList'
import DrillTopicGridLayout from '~/components/Drill/DrillTopic/components/DrillTopicGridLayout'
import DrillTopicGridWrapper from '~/components/Drill/DrillTopic/components/DrillTopicGridWrapper'
import LianaDesktop from '~/components/Drill/DrillTopic/components/LianaDesktop'
import LianaMobile from '~/components/Drill/DrillTopic/components/LianaMobile'
import LianaTablet from '~/components/Drill/DrillTopic/components/LianaTablet'
import useGetGridPositionFunction from '~/components/Drill/hooks/useGetGridPositionFunction'
import { TopicData } from '~/types/theory'
import { processTopics } from '~/components/Drill/DrillTopic/helpers'

import { getGridPosition } from './Factorization.grid'
import { getProperties } from './Factorization.properties'

export default function Factorization({
  topics,
  drillUrl,
}: {
  topics: TopicData[] | undefined
  drillUrl: string
}): React.ReactElement {
  const { t } = useTranslation(['drill'])
  const getGridPositionFunction = useGetGridPositionFunction(getGridPosition)
  const processedTopics = processTopics(topics, getGridPositionFunction, getProperties)

  const mobileGridRows = 'grid-rows-[repeat(8,70px)]'
  const tabletGridRows = 'md:grid-rows-[repeat(4,70px)]'
  const desktopGridRows = 'xl:grid-rows-[repeat(4,70px)]'

  return (
    <DrillTopicGridWrapper>
      <div className="md:hidden">
        <LianaMobile height={800} />
      </div>
      <div className="hidden md:block xl:hidden">
        <LianaTablet
          height={438}
          image="math-drills/factorization/beanstalk-tablet.png"
          imageAlt={t('drill:imageAlt.factorizationBeanStalkDesktop')}
        />
      </div>
      <div className="hidden xl:block">
        <LianaDesktop
          classNames="-top-36 left-36 w-[590px]"
          image="math-drills/factorization/beanstalk-desktop.png"
          imageAlt={t('drill:imageAlt.factorizationBeanStalkTablet')}
        />
      </div>
      <DrillTopicGridLayout className={[mobileGridRows, tabletGridRows, desktopGridRows].join(' ')}>
        <DrillTopicElementsList drillUrl={drillUrl} topics={processedTopics} />
      </DrillTopicGridLayout>
    </DrillTopicGridWrapper>
  )
}
